import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// import 'swiper/dist/css/swiper.css';
import 'swiper/swiper-bundle.css'
import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper)

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

import {post,fetch,patch,put,ossUrl,callAPI} from './utils/http'

// import axiosApi from "./utils/http"
// Vue.prototype.axiosApi = axiosApi;

// import {callAPI} from "./utils/http"
Vue.prototype.$exec = callAPI;

//定义全局变量
Vue.prototype.$post=post;
Vue.prototype.$fetch=fetch;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;
Vue.prototype.$url = ossUrl;

// import i18n from './i18n/i18n'

import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)
// Vue.use(ElementUI, {size: 'small'});

import i18n from './i18n/i18n'
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, { locale })
Vue.use(i18n)

import animated from 'animate.css'
 
Vue.use(animated)

import setting from './setting'
Vue.use(setting)


Vue.config.productionTip = false

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
